import { createLevelInLevelMap, LevelMap } from "../../levels/LevelMap";
import { useRecoilState } from "recoil";
import { currentLevelSelector } from "../../atoms/currentLevelAtom";
import { deleteLevel } from "../../helpers/deleteLevel";
import { isChangeLevelMenuOpenAtom } from "../../atoms/changeLevelMenuAtom";
import ElevatorLevelSelect from "./ElevatorLevelSelect";
import sounds from "../../classes/Sounds";

export default function ChangeLevelMenu({ onBackToTitle }) {
  const [currentLevel, setCurrentLevel] = useRecoilState(currentLevelSelector);
  const [isChangeLevelMenuOpen, setIsChangeLevelMenuOpen] = useRecoilState(
    isChangeLevelMenuOpenAtom
  );

  // Show nothing if the menu is not open
  if (!isChangeLevelMenuOpen) {
    return null;
  }

  const customLevels = Object.keys(LevelMap)
    .map((key) => {
      return { ...LevelMap[key], key };
    })
    .filter((levelData) => {
      return levelData.isEditableByUser;
    });

  return (
    <ElevatorLevelSelect
      currentLevel={currentLevel}
      customLevels={customLevels}
      onLoadLevel={(newLevelId) => {
        const levelExists = LevelMap[newLevelId];
        if (!levelExists) {
          console.log("This level does not exist yet.");
          return;
        }

        setCurrentLevel(newLevelId);
        setIsChangeLevelMenuOpen(false);
      }}
      onDeleteLevel={(key) => {
        deleteLevel(key);
      }}
      onCreateNewLevel={() => {
        const createdId = createLevelInLevelMap();
        setCurrentLevel(createdId);
        setIsChangeLevelMenuOpen(false);
      }}
      onBackToTitle={() => {
        //Stop music
        sounds.stopMusic();

        // Close this menu
        setIsChangeLevelMenuOpen(false);
        //Move us to Title
        onBackToTitle();
      }}
    />
  );
}
